import React from "react";
import "./Header.scss";
import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import FormatQuoteOutlinedIcon from "@mui/icons-material/FormatQuoteOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import { experimentalStyled as styled } from "@mui/material/styles";
import LogoutIcon from "@mui/icons-material/Logout";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import { LogOutRequest } from "../../../Redux/Login.slice";
import { Backdrop, CircularProgress } from "@mui/material";

// const Item = styled(Paper)(({ theme }) => ({
//   ...theme.typography.body2,
//   padding: theme.spacing(2),
//   textAlign: "center",
//   color: theme.palette.text.secondary,
// }));

const ShowSidebar1 = () => {
  document.body.classList.add("body-active");
};
const ShowSidebar2 = () => {
  document.body.classList.remove("body-active");
};
export default function Header() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { logOutStatus, userDetails } = useSelector((s) => s.login);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(LogOutRequest(userDetails?._id));
  };
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={logOutStatus === "loading" ? true : false}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="ovelay-con" onClick={ShowSidebar2}>
        &nbsp;
      </div>
      <header className="header-main">
        <div className="top-nav">
          <Link className="logo" >
             {/* <img alt="logo"  src="/assets/images/logo2.png" />  */}
             <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 497 116.7"
              // width="497"
              // height="116.7"
            >
              <path
                d="M89 42.8v-8.3l62.4-28.6v11zM23.1 53.2V59l96.8-48.6V0zM0 79.6l53.4-22.1v-6.7L0 75.2z"
                fill="#FF6441"
              ></path>
              <path
                d="M409.1 49.1l-12.9 29.5h7.5l2.8-6.4h14.9l2.8 6.4h7.9l-12.8-29.5h-10.2zm-.1 17.4l5-11.4 5 11.4h-10zm-95.8 12.1h5.7l7.9-16.6v16.6h7.1V49.1h-8.4l-9.4 21.4-9.4-21.4H298v29.5h7.1V62l8.1 16.6zm-167 0h5.7l7.9-16.6v16.6h7.1V49.1h-8.4l-9.4 21.4-9.4-21.4H131v29.5h7.1V62l8.1 16.6zm107.7-29.5v6.1h-20.5v6h17.1v5.9h-17.1v5.5h20.4v6.1h-28V49.2h28.1v-.1zm-185.8 0L55.2 78.6h7.5l2.8-6.4h14.9l2.8 6.4h7.9L78.3 49.1H68.1zM68 66.5l5-11.4 5 11.4H68zm49.8-4h-14.4v-7.6h14.4v7.6zM95.5 49.1v29.5h7.7v-10h17.3c2.2 0 4-1.3 4.2-4.2v-11c0-2.4-2.1-4.3-4.6-4.3H95.5zm349.3 0h-7.7v29.5h26.5v-6.1h-18.8V49.1zm-86 0v29.5h7.6V58.3l16.3 20.3h8.4V49.1h-7.7v20.3l-15.9-20.3h-8.7zm-16.2 29.5h7.4V49.2h-7.4v29.4zM187.9 49.1v6.3h11.9v23.2h7.9V55.4h11.9v-6.3h-31.7zm285.4 0c-2.2-.1-4.3 1.9-4.3 4v9.6c0 2.5 2.1 4.3 4.2 4.3h17.1v5.7h-13.6v-2.4h-8v4.1c0 2.2 2 4.3 4.3 4.3h20.8c2.1 0 4.2-1.6 4.2-4.4v-9.2c-.1-2.7-2.1-4.3-4.3-4.4h-16.8v-5.5h13.2v1.9h7.5v-3.9c.1-1.9-1.8-4.1-4.3-4h-20v-.1zm-212.4 0v29.5h7.5V67.8h8.6l5.8 10.8h8l-6-10.8h.7c2.3-.2 4-1.9 4-4.4v-10c0-2.4-2.1-4.3-4.6-4.3h-24zm21.9 12.8h-14.5v-6.7h14.5v6.7z"
                fill="#3c3c46"
              ></path>
              <path
                d="M293.1 108.7v1.8h-10.4v-17h2.2v15.2h8.2zM295.5 93.2h2.4v2.4h-2.4v-2.4zm.1 4.7h2.1v12.6h-2.1V97.9zM309.4 99.6h-4.5v11h-2.1v-11h-2.5v-1.7h2.5v-1c0-2.2.9-4.3 4.5-4.3.7 0 1.5.1 2 .3v1.7c-.5-.1-1.2-.2-1.9-.2-1.6 0-2.6.7-2.6 2.6v1h4.5v1.6h.1zM313.4 106.8v-7.2h-2.3v-1.7h2.3v-3l2.1-.6v3.6h4v1.7h-4v7.2c0 2 .9 2.2 1.8 2.2.8 0 1.8-.2 2.3-.4v1.7c-.6.2-1.6.4-2.7.4-2.4.1-3.5-1.1-3.5-3.9zM322 93.2h2.4v2.4H322v-2.4zm.2 4.7h2.1v12.6h-2.1V97.9zM328 97.9h1.8l.2 1.1c0 .2.1.2.2.2s.2 0 .4-.2c.8-.6 2-1.3 4-1.3 2.5 0 3.8 1.1 3.8 3.7v9.2h-2.1v-8.7c0-1.9-.9-2.4-2.4-2.4-1.7 0-3.1.8-3.8 1.4v9.7H328V97.9zM341.1 112.4c0-1.4 1-2.6 2.2-3.5-1-.4-1.4-1-1.4-1.9 0-.8.5-1.5 1.2-2-1-.7-1.6-1.9-1.6-3.2 0-2.9 1.6-4.2 5.4-4.2.7 0 1.3.1 2 .2h4.5l.2 1.2-2.3.3c.5.6.8 1.5.8 2.4 0 2.9-1.6 4.2-5.2 4.2-.9 0-1.8-.1-2.5-.4-.4.3-.6.7-.6 1.1 0 .6.4.8 1.6 1l4.9 1c1.8.4 2.7 1.6 2.7 3.3 0 2.6-1.8 3.7-6 3.7-4.1.3-5.9-.8-5.9-3.2zm9.7-.1c0-1.1-.6-1.7-1.9-2l-4.3-.9c-.9.9-1.5 1.7-1.5 2.6 0 1.5 1.2 2.2 3.8 2.2 2.9 0 3.9-.5 3.9-1.9zm-.8-10.4c0-2-.8-2.6-3.1-2.6-2.4 0-3.3.7-3.3 2.6 0 1.9.9 2.6 3.2 2.6 2.3-.1 3.2-.8 3.2-2.6zM361.5 102c0-6.3 2.3-8.7 7.6-8.7 2.2 0 3.8.4 4.4.7v1.9c-.6-.2-2.2-.7-4.3-.7-4.3 0-5.5 2-5.5 6.7 0 5.8 1.9 7 4.4 7 1.9 0 3.2-.7 4.1-1.1v-4.6h-3.6v-1.8h5.7v9.1h-1.7l-.2-.9c0-.1-.1-.3-.2-.3s-.2 0-.4.2c-.5.3-2.1 1.2-4.1 1.2-3.7.1-6.2-2.1-6.2-8.7zM377.8 107.8v-15h2.1v14.6c0 1.1.4 1.6 1.3 1.6.5 0 .8 0 1.3-.1v1.7c-.5.1-1.1.2-1.8.2-1.7 0-2.9-1-2.9-3zM384.2 104.2c0-4.7 1.9-6.6 5.8-6.6s5.8 1.8 5.8 6.6-1.9 6.6-5.8 6.6-5.8-1.8-5.8-6.6zm9.4 0c0-3.5-1.1-4.8-3.6-4.8-2.6 0-3.6 1.3-3.6 4.8s1 4.8 3.6 4.8 3.6-1.3 3.6-4.8zM399 109.9V92.8h2.1v6.3c.5-.3 2.1-1.4 4.1-1.4 2.8 0 4.8 1.2 4.8 6.4 0 5.1-1.8 6.8-5.9 6.8-2.4-.1-4-.6-5.1-1zm8.8-5.8c0-3.6-1-4.6-3.1-4.6-1.8 0-3 .8-3.6 1.2v7.9c.6.2 1.5.5 3 .5 2.3-.1 3.7-1.1 3.7-5zM412.5 107.3c0-2.2 1.1-3 4-3.8l3.9-1.2v-.6c0-1.2-.6-2.3-3-2.3-1.8 0-3.2.5-4 .8v-1.8c1-.4 2.4-.8 4.3-.8 3.3 0 4.8 1.5 4.8 4.1v8.8h-1.8l-.2-1.1c0-.2-.1-.2-.2-.2s-.2 0-.3.1c-.7.5-2.3 1.4-4 1.4-2.5.1-3.5-1-3.5-3.4zm7.8.6v-4l-3.7 1.1c-1.7.5-2.1 1-2.1 2.2 0 1.3.5 1.9 1.9 1.9 1.5 0 2.9-.7 3.9-1.2zM426 107.8v-15h2.1v14.6c0 1.1.4 1.6 1.3 1.6.5 0 .8 0 1.3-.1v1.7c-.5.1-1.1.2-1.8.2-1.7 0-2.9-1-2.9-3zM443.4 95.3H438v-1.8h12.9v1.8h-5.4v15.2h-2.2V95.3h.1zM451.4 97.9h1.8l.2 1.3c0 .2.1.3.2.3s.2 0 .3-.2c.8-.7 2.1-1.6 3.8-1.6.2 0 .5 0 .7.1v1.9c-1.6-.1-3.4.4-4.8 1.5v9.4h-2.1V97.9h-.1zM460.1 107.3c0-2.2 1.1-3 4-3.8l3.9-1.2v-.6c0-1.2-.6-2.3-3-2.3-1.8 0-3.2.5-4 .8v-1.8c1-.4 2.4-.8 4.3-.8 3.3 0 4.8 1.5 4.8 4.1v8.8h-1.8l-.2-1.1c0-.2-.1-.2-.2-.2s-.2 0-.3.1c-.7.5-2.3 1.4-4 1.4-2.4.1-3.5-1-3.5-3.4zm7.9.6v-4l-3.7 1.1c-1.7.5-2.1 1-2.1 2.2 0 1.3.5 1.9 1.9 1.9 1.5 0 2.9-.7 3.9-1.2zM473.1 104.2c0-4.9 2.1-6.6 5.5-6.6 1.5 0 2.6.3 3.4.8v-5.6h2.1v17.7h-1.8l-.2-1.1c0-.1-.1-.2-.2-.2s-.1 0-.2.1c-.5.5-1.9 1.4-3.7 1.4-2.7.1-4.9-1.4-4.9-6.5zm8.9 3.4V100c-.6-.3-1.7-.6-3-.6-2.6 0-3.7 1.2-3.7 4.8s1.3 4.8 3.2 4.8c1.5 0 2.9-.9 3.5-1.4zM497.9 104.7h-8.5c.1 3.1 1.3 4.2 3.9 4.2 1.9 0 3.4-.6 4.3-1v1.9c-.8.4-2.2.9-4.4.9-4.2 0-5.8-2.2-5.8-6.9 0-4.6 1.9-6.2 5.5-6.2 3.5 0 5.1 1.8 5.1 5.3l-.1 1.8zm-2-2.2c0-2.1-1-3.1-3.2-3.1-2.3 0-3.3.9-3.4 3.8h6.5v-.7h.1z"
                fill="#FF6441"
              ></path>
            </svg> 
          </Link>
          <ul className="mobile-nav">
            <li>
              <Link to="/">
                <HomeOutlinedIcon className="top-icon home-icon" />
                Peel Pile
              </Link>
            </li>
            <li>
              <Link to="/terminals">
                <FormatQuoteOutlinedIcon className="top-icon quote-icon" />
                Appointments
              </Link>
            </li>
            {/* <li>
              <Link to="#">
                <StickyNote2OutlinedIcon className="book-icon top-icon" />
                Book
              </Link>
            </li>
            <li>
              <Link to="#">
                <ListAltOutlinedIcon className="top-icon rates-icon" />
                Rates
              </Link>
            </li>
            <li>
              <Link to="#">
                <TimelineOutlinedIcon className="top-icon dashedboard-icon" />
                Dashboard
              </Link>
            </li> */}
          </ul>
        </div>
        <div className="right-nav mobile-nav">
          <ul>
            {/* <li>
              <Link to="#">
                <SearchOutlinedIcon />
              </Link>
            </li>
            <li>
              <Link to="#">
                <DraftsOutlinedIcon />
              </Link>
            </li>
            <li>
              <Link to="#">
                <SettingsOutlinedIcon />
              </Link>
            </li> */}
            <li>
              <a>
                <AccountCircleOutlinedIcon
                  id="basic-menu"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                />
              </a>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
                <MenuItem onClick={handleClose}>My account</MenuItem> */}
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </li>
          </ul>
        </div>
        <MenuOutlinedIcon onClick={ShowSidebar1} className="menu-icon" />
        <div className="mobile-menu">
          <CancelOutlinedIcon onClick={ShowSidebar2} className="cancel-icon1" />
          <div className="top-nav">
            <ul>
              <li>
                <Link to="/">
                  <HomeOutlinedIcon className="top-icon home-icon" />
                  Peel Pile
                </Link>
              </li>
              <li>
                <Link to="/terminals">
                  <FormatQuoteOutlinedIcon className="top-icon quote-icon" />
                  Appointments
                </Link>
              </li>
              <li>
                <a onClick={handleLogout}>
                  <LogoutIcon className="top-icon quote-icon" />
                  Log out
                </a>
              </li>
              {/* <li>
                <Link to="#">
                  <HomeOutlinedIcon className="top-icon home-icon" />
                  Arrive
                </Link>
              </li>
              <li>
                <Link to="#">
                  <FormatQuoteOutlinedIcon className="top-icon quote-icon" />
                  Quote
                </Link>
              </li>
              <li>
                <Link to="#">
                  <StickyNote2OutlinedIcon className="book-icon top-icon" />
                  Book
                </Link>
              </li>
              <li>
                <Link to="#">
                  <ListAltOutlinedIcon className="top-icon rates-icon" />
                  Rates
                </Link>
              </li>
              <li>
                <Link to="#">
                  <TimelineOutlinedIcon className="top-icon dashedboard-icon" />
                  Dashboard
                </Link>
              </li> */}
            </ul>
          </div>
          <div className="right-nav">
            <ul>
              {/* <li>
                <Link to="#">
                  <SearchOutlinedIcon />
                </Link>
              </li>
              <li>
                <Link to="#">
                  <DraftsOutlinedIcon />
                </Link>
              </li>
              <li>
                <Link to="#">
                  <SettingsOutlinedIcon />
                </Link>
              </li> */}
              {/* <li>
                <a>
                  <AccountCircleOutlinedIcon
                    id="basic-menu"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  />
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </header>
    </>
  );
}
